import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Form, Input, Cascader, Button, Select, Checkbox } from 'antd';

import { createOrganization } from '../actions';

const REQUEST_TYPE_CUSTOM = 'custom';
const REQUEST_TYPE_GOOGLE_PLACES = 'googlePlaces';

const countryOptions = [
	{ key: 'AU', value: 'AU', text: 'Australia' },
	{ key: 'NZ', value: 'NZ', text: 'New Zealand' },
	{ key: 'SG', value: 'SG', text: 'Singapore' }
];

const parseCategoriesIntoOptions = (categories) => {
	return categories.map((cat) => (
		{
			value: cat.name,
			label: cat.name,
			children: cat.subcategories.map((sub) => (
				{
					value: sub.name,
					label: sub.name,
				}	 	
			))
		}
	));
};

class OrganizationCreate extends Component {
	constructor(props) {
		super(props);
		this.onInputChange = this.onInputChange.bind(this);
		this.onCountryChange = this.onCountryChange.bind(this);
		this.onCategoryChange = this.onCategoryChange.bind(this);
		this.onCheckboxChange = this.onCheckboxChange.bind(this);
		this.onLeaseCheckboxChange = this.onLeaseCheckboxChange.bind(this);
		this.onSave = this.onSave.bind(this);
		this.hasErrors = this.hasErrors.bind(this);
		this.state = {
			name: '',
			country: 'AU',
			category: '',
			subcategory: '',
			importPOIsFromGoogle: false,
			lease: false
		};
	}

	onInputChange(e) {
		const target = e.target;
		this.setState(() => ({
			[target.id]: target.value
		}));
	}

	onCheckboxChange(e) {
		const target = e.target;
		this.setState(() => ({
			[target.id]: target.checked
		}));
	}

	onCountryChange(value) {
		this.setState(() => ({
			country: value
		}));
	}

	onCategoryChange(selected) {
		this.setState(() => ({
			category: selected[0],
			subcategory: selected[1],
		}));
	}

	onLeaseCheckboxChange(e) {
		const target = e.target;
		this.setState(() => ({
			[target.id]: target.checked
		}));
	}
	hasErrors() {
		return !(this.state.name && this.state.category && this.state.subcategory && this.state.country);
	}

	onSave() {
		this.props.createOrganization({
			requestType: this.state.importPOIsFromGoogle ? REQUEST_TYPE_GOOGLE_PLACES : REQUEST_TYPE_CUSTOM,
			name: this.state.name,
			category: this.state.category,
			subcategory: this.state.subcategory,
			version: 3,
			country: this.state.country,
			lease: this.state.lease,
			organisationType: 'physical'
		});
	}

	render() {
		return (
			<div>
				<div className="container-with-padding">
					<h4 className="heading-level-1" style={{ marginBottom: 16 }}>Create Organization</h4>
					<Form>
						<Form.Item label="Name" style={{ marginBottom: 5 }}>
							<Input
								id="name"
								onChange={this.onInputChange}
								value={this.state.name}
								placeholder="Organization name"
							/>
						</Form.Item>
						<Form.Item label="Country" style={{ marginBottom: 5 }}>
							<Select
								onChange={this.onCountryChange}
								dropdownMatchSelectWidth={true}
								defaultValue={'AU'}
								placeholder='Country'
								style={{ width: '100%' }}
							>
								{
									countryOptions.map((country) => (
										<Select.Option key={country.key}>
											{country.text}
										</Select.Option>
									))
								}
							</Select>
						</Form.Item>
						<Form.Item label="Categories/Subcategories" style={{ marginBottom: 10 }}>
							<Cascader
								options={parseCategoriesIntoOptions(this.props.categories)}
								onChange={this.onCategoryChange}
								value={this.state.category && this.state.subcategory ? [this.state.category, this.state.subcategory] : null}
								placeholder="Please select"
							/>
						</Form.Item>
						<Form.Item label="Import POIs from Google" style={{ marginBottom: 5 }}>
							<Checkbox
								id="importPOIsFromGoogle"
								onChange={this.onCheckboxChange}
								value={this.state.importPOIsFromGoogle}
							/>
						</Form.Item>
						<Form.Item label="Lease?" style={{ marginBottom: 5 }}>
							<Checkbox
								id="lease"
								onChange={this.onLeaseCheckboxChange}
								value={this.state.lease}
							/>
						</Form.Item>
						<Form.Item>
							<Button type="primary" disabled={this.hasErrors()} icon="save" onClick={this.onSave}>
								Save Organization
							</Button>
						</Form.Item>
					</Form>
				</div>
			</div>
		)
	}
}

OrganizationCreate.propTypes = {
	createOrganization: PropTypes.func,
	categories: PropTypes.arrayOf(PropTypes.shape(
		{
			name: PropTypes.string,
			subcategories: PropTypes.array,
		}
	)),
}

OrganizationCreate.defaultProps = {
	categories: [],
};

// Map props to the store

const mapStateToProps = (state) => ({
	categories: state.common.getIn(['categories']),
});

const mapDispatchToProps = (dispatch) => ({
	createOrganization: (organization) => {
		dispatch(createOrganization(organization));
	}
});

export const OrganizationsCreateContainer = connect(mapStateToProps, mapDispatchToProps)(OrganizationCreate);



// WEBPACK FOOTER //
// ./src/organizations/components/OrganizationCreate.js